module.exports = "/static-assets/_next/static/images/og-image-1fc736ba5fbf2b385a2bcad48c1f50e3.png";